'use strict';
var __assign =
	(this && this.__assign) ||
	function () {
		__assign =
			Object.assign ||
			function (t) {
				for (var s, i = 1, n = arguments.length; i < n; i++) {
					s = arguments[i];
					for (var p in s)
						if (Object.prototype.hasOwnProperty.call(s, p))
							t[p] = s[p];
				}
				return t;
			};
		return __assign.apply(this, arguments);
	};
var __rest =
	(this && this.__rest) ||
	function (s, e) {
		var t = {};
		for (var p in s)
			if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
				t[p] = s[p];
		if (s != null && typeof Object.getOwnPropertySymbols === 'function')
			for (
				var i = 0, p = Object.getOwnPropertySymbols(s);
				i < p.length;
				i++
			)
				if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
		return t;
	};
Object.defineProperty(exports, '__esModule', { value: true });
var React = require('react');
var prop_types_1 = require('../../types/prop.types');
var SafeAnchorRole;
(function (SafeAnchorRole) {
	SafeAnchorRole['Button'] = 'button';
	SafeAnchorRole['Link'] = 'link';
	SafeAnchorRole['MenuItem'] = 'menuitem';
	SafeAnchorRole['Option'] = 'option';
	SafeAnchorRole['Tab'] = 'tab';
})((SafeAnchorRole = exports.SafeAnchorRole || (exports.SafeAnchorRole = {})));
var isTrivialHref = function (href) {
	return !href || href.trim() === '#' || href.trim() === 'javascript:void(0)';
};
var handleClick = function (event, trivialHref, disabled, onClick) {
	var shouldNavigate = true;
	if (disabled || trivialHref) {
		event.preventDefault();
		shouldNavigate = false;
	}
	if (disabled) {
		event.stopPropagation();
		return false;
	}
	if (onClick) {
		onClick(event);
	}
	return shouldNavigate;
};
function handleKeyDown(event, trivialHref, disabled, onClick, onKeyDown) {
	if (event.key === ' ') {
		event.preventDefault();
		if (!onKeyDown) {
			handleClick(event, trivialHref, disabled, onClick);
		}
	}
	if (onKeyDown) {
		onKeyDown(event);
	}
}
var SafeAnchor = function (_a) {
	var disabled = _a.disabled,
		onClick = _a.onClick,
		onKeyDown = _a.onKeyDown,
		children = _a.children,
		anchorRef = _a.anchorRef,
		restProps = __rest(_a, [
			'disabled',
			'onClick',
			'onKeyDown',
			'children',
			'anchorRef',
		]);
	var trivialHref = isTrivialHref(restProps.href);
	return React.createElement(
		'a',
		__assign(
			{
				ref: anchorRef,
				onClick: function (e) {
					return handleClick(e, trivialHref, disabled, onClick);
				},
				onKeyDown: function (e) {
					return handleKeyDown(
						e,
						trivialHref,
						disabled,
						onClick,
						onKeyDown
					);
				},
			},
			restProps
		),
		children
	);
};
exports.SafeAnchor = SafeAnchor;
SafeAnchor.Role = SafeAnchorRole;
SafeAnchor.Target = prop_types_1.AnchorTarget;
SafeAnchor.defaultProps = {
	href: 'javascript:void(0)',
	role: SafeAnchorRole.Button,
};
//# sourceMappingURL=SafeAnchor.js.map
